export enum AuthenticationType {
    noAuth = 'noAuth',
    bearerToken = 'bearerToken',
}
